import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import {
  NextProject,
  ProjectAwards,
  ProjectBannerImage,
  ProjectDescription,
  ProjectDownloads,
  ProjectImpacts,
  ProjectLinks,
  ProjectListTextImage,
  ProjectVideos,
} from '../atoms';
import BannerSlider from '../modules/BannerSlider/BannerSlider';

// Search this string (projectRestinga) in translations
const pathProject = "projectRestinga";

const ProjectRestinga = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lng = localStorage.getItem("language");
    i18n.changeLanguage(lng);
  }, [i18n])

  return (
    <div className='projectLayout'>
      <Helmet>
        <title>Restinga | Instituto E</title>
      </Helmet>
      <BannerSlider
        slides={
          [
            {
              image: "../../../images/projects/restinga/1.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/restinga/2.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/restinga/3.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/restinga/4.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/restinga/5.jpg",
              alt: "description alt image",
            },            
            {
              image: "../../../images/projects/restinga/6.jpg",
              alt: "description alt image",
            }
          ]}>
      </BannerSlider>

      {/* Possible to import all inside div with class: "projectLayoutContent", in the following order:
          - ProjectDescription
          - ProjectImpacts
          - ProjectAwards
          - ProjectLinks
          - ProjectVideos
          - ProjectDownloads
          - Outside the div: ProjectBannerImage
          - Outside the div: ProjectListTextImage */}

      <div className='projectLayoutContent'>
        <ProjectDescription
          title={`${t(`${pathProject}.title`)}`}
          subtitle={`${t(`${pathProject}.subtitle`)}`}
          paragraphs={[
            {
              type: "text",
              p: `${t(`${pathProject}.p1`)}`
            },
            {
              type: "text",
              p: `${t(`${pathProject}.p2`)}`
            }
          ]} />

        <ProjectImpacts
          impacts={[
            {
              impactTitle: `${t(`${pathProject}.impactTitle1`)}`,
              impactSubtitle: `${t(`${pathProject}.impactSubtitle1`)}`
            },
            {
              impactTitle: `${t(`${pathProject}.impactTitle2`)}`,
              impactSubtitle: `${t(`${pathProject}.impactSubtitle2`)}`
            },
            {
              impactTitle: `${t(`${pathProject}.impactTitle3`)}`,
              impactSubtitle: `${t(`${pathProject}.impactSubtitle3`)}`
            },
            {
              impactTitle: `${t(`${pathProject}.impactTitle4`)}`,
              impactSubtitle: `${t(`${pathProject}.impactSubtitle4`)}`
            }
          ]} />

        <ProjectVideos
          videos={[
            {
              linkYT: 'https://www.youtube.com/watch?v=t_Z9J-NTHUI&t=4s&ab_channel=Instituto-e',
              textVideo: `${t(`${pathProject}.videoText1`)}`
            }
          ]} />
      </div>

      <NextProject link="project-portobello"></NextProject>

    </div>
  )
};

export default ProjectRestinga;
